<template>
  <el-table :data="appraises" border style="width: 100%" class="table">
    <el-table-column :label="$t('servAppraiseManage.table.servName')" align="center" min-width="120" show-overflow-tooltip>
      <template slot-scope="scope">
        {{ scope.row.servName || scope.row.prodName || scope.row.objId || '-' }}
      </template>
    </el-table-column>
    <el-table-column prop="appraiseUserName" :label="$t('servAppraiseManage.table.appraiseUserName')" align="center" width="120" />
    <el-table-column prop="appraiseScore" :label="$t('servAppraiseManage.table.appraiseScore')" align="center" width="90" />
    <el-table-column prop="context" :label="$t('servAppraiseManage.table.context')" align="center" min-width="160" show-overflow-tooltip />
    <el-table-column :label="$t('servAppraiseManage.table.imgPath')" align="center" width="120">
      <template slot-scope="scope">
        <template v-if="scope.row.imgPath">
          <el-image
            v-for="(img, idx) in getImgList(scope.row.imgPath)"
            :key="idx"
            :src="img"
            :preview-src-list="getImgList(scope.row.imgPath)"
            style="width: 40px; height: 40px; margin-right: 4px"
            fit="cover"
          />
        </template>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column prop="createTime" :label="$t('servAppraiseManage.table.createTime')" align="center" width="160" />
    <el-table-column :label="$t('servAppraiseManage.table.operation')" align="center" width="160" fixed="right">
      <template slot-scope="scope">
        <el-button type="text" size="mini" @click="$emit('edit-appraise', scope.row)">
          {{ $t('servAppraiseManage.table.editBtn') }}
        </el-button>
        <el-button type="text" size="mini" style="color: #F56C6C" @click="$emit('delete-appraise', scope.row)">
          {{ $t('servAppraiseManage.table.deleteBtn') }}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ServAppraiseManageTable',
  props: {
    appraises: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getImgList(imgPath) {
      if (!imgPath) {
        return []
      }
      return String(imgPath).split('|').filter(item => !!item)
    }
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 20px;
}
</style>
